import * as React from 'react';

import { declineNumeric } from '../../helpers/format_helper';
import { IService } from '../../models/service';
import { Button, PhoneField, Preloader, VisualSize } from '@cian/components';
import { Tooltip } from '@cian/tooltip-component';
import { Link } from '../link/link';

const s = require('./sms_form.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
  onPremClick(eventLabel: string): void;
  service: IService;
  onSendSMS: (phone: string) => void;
  onResendSMS: () => void;
  timerCount?: number;
}

interface IState {
  value: string;
  cooldown: number;
}

export class SmsForm extends React.Component<IProps, IState> {

  public constructor(props: IProps) {
    super(props);
    this.state = { value: '', cooldown: this.props.timerCount || 60 };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.service.isFetching === false && newProps.service.isSended === true) {
      let cooldown = this.props.timerCount || 60;
      const timer = setInterval(() => {
        if (cooldown <= 0) {
          clearInterval(timer);
        } else {
          cooldown -= 1;
          this.setState(Object.assign({}, this.state, { cooldown }));
        }
      }, 1000);
    }
  }

  public render() {
    return (
      <div className={s['c-sms-form-content']}>
        <h4 className={s['c-sms-form-title']}>Получите ссылку для скачивания приложения</h4>
        {!this.props.service.isSended &&
          <form onSubmit={this.onSubmit}>
            <div className={s['c-sms-form']}>
              <Tooltip tooltipContent={this.props.service.error || ''}>
                <PhoneField
                  mobile
                  size={VisualSize.SMALL}
                  value={this.state.value}
                  onValueChange={this.onChange}
                  inputStyle={s['c-sms-form-input']}
                  />
              </Tooltip>
            </div>
            {
              this.props.service.isFetching
                ? <Preloader preloaderStyle={s['c-sms-form-preloader']}/>
                : <Button buttonStyle={s['c-sms-form-submit']} type="submit">Отправить</Button>
            }
          </form>
        }
        {this.props.service.isSended &&
          <div>
            <p className={s['c-sms-form-sent-text']}>На <b>{this.props.service.phone}</b> отправлено СМС со ссылкой.</p>
            <div className={s['c-sms-form-send-again']}>
              {
                this.state.cooldown > 0
                  ? <span className={s['c-sms-form-send-again-count']}>
                    Отправить снова можно через{' ' + this.state.cooldown + ' ' +
                      declineNumeric(this.state.cooldown, ['секунду', 'секунды', 'секунд'])}
                  </span>
                  : <Link className={s['c-sms-form-send-again-link']} onClick={this.props.onResendSMS}>Отправить снова</Link>
              }
            </div>
          </div>
        }
      </div>
    );
  }

  private onChange(phone: string) {
    this.setState(Object.assign({}, this.state, { value: phone }));
  }

  private onSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.onAdsClick('get_APP_link');

    if (!this.props.service.isFetching) {
      this.props.onSendSMS(this.state.value);
    }
  }

}
